<!--appSvg2-->
<template>
  <div id="app_svg_body">
    <iframe class="iframe" height="600" scrolling="auto" frameborder="0" marginheight="0" marginwidth="0"
      src="http://120.27.16.122:8888/hdlpd/#/jufangCheckIndex"></iframe>

  </div>
</template>

<script>
  export default {
    components: {},
    props: {},
    data () {
      return {
        nowScale: 50, //当前缩放倍率
        token: '', //token
        ids: [],
        svgPath: '',
      }
    },

    methods: {
      resetSize () {
        //缩放到指定倍率大小
        var svgframe=this.$refs.svgframe
        if(svgframe==undefined||svgframe.getSVGDocument()==undefined) {
          return
        }
        //获取svg内容对象
        var svg=svgframe.getSVGDocument().documentElement
        //调整viewbox至刚好显示全屏
        svg.setAttribute("width",svgframe.offsetWidth*(this.nowScale/50)-2)
        svg.setAttribute("height",svgframe.offsetHeight*(this.nowScale/50)-2)
        /*svg.setAttribute("style","transform: rotate(90deg)")*/
      },
      getNowIds () {
        //获取当前变量列表
        var svgframe=this.$refs.svgframe
        if(svgframe==undefined||svgframe.getSVGDocument()==undefined) {
          return
        }
        //获取svg内容对象
        var svg=svgframe.getSVGDocument().documentElement
        //重新获取IDS
        var ids=[]
        var devices=svg.getElementsByTagName('text')
        for(var i=0;i<devices.length;i++) {
          var item=devices[i].getAttribute('DeviceNo')
          if(!isempty(item)) {
            ids.push(item)
          }
        }
        var uses=svg.getElementsByTagName('use')
        for(var i=0;i<uses.length;i++) {
          var item=uses[i].getAttribute('DeviceNo')
          if(!isempty(item)) {
            ids.push(item)
          }
        }
        this.ids=ids
      },
      getMacRealValueCallback (values) {
        var doc=this.$refs.svgframe.getSVGDocument().getElementsByTagName("svg")[0]
        var devices=doc.getElementsByTagName('text')
        var uses=doc.getElementsByTagName('use')
        this.ids.forEach((item,index) => {
          var value=values[index]
          if(value!=undefined) {
            value=value.split(':')[0]
          }
          if(value==undefined) {
            return
          }
          //找到元素,赋值
          for(var i=0;i<devices.length;i++) {
            if(devices[i].getAttribute('DeviceNo')==item) {
              var fm=devices[i].getAttribute("format");
              if(isempty(fm)) {
                fm="#0.00"
              }
              //一般是#0.00这样的，有时候会加单位在后面，我们要把#0.00部分其替换成值
              if(fm.indexOf("#0.")!=-1) {
                var len=fm.length-3
                for(var j=0;j<fm.length-3;j++) {
                  if(fm.charAt(j+3)!='0') {
                    len=j
                    break
                  }
                }
                fm=fm.substring(len+3)
                value=parseFloat(value).toFixed(len)+fm
              }
              devices[i].textContent=isempty(value)? "--":value
            }
          }
          for(var i=0;i<uses.length;i++) {
            if(uses[i].getAttribute('DeviceNo')==item) {
              //样式，不为0就在后面加上状态
              var link=uses[i].getAttribute("xlink:href")
              //缓存的上一次状态
              var state=uses[i].getAttribute("state")
              if(state!=0) {
                //移除一下原来的样式
                link=link.substring(0,link.lastIndexOf(state))
              }
              var newState=parseInt(value)
              //刷新图符样式
              if(newState!=0) {
                link=link+newState
              }
              uses[i].setAttribute("xlink:href",link)
              uses[i].setAttribute("state",newState)
            }
          }
        })
      },
      svgDataPage (values) {
        //获取所有的图元方法
        var doc=this.$refs.svgframe.getSVGDocument().getElementsByTagName("svg")[0]
        var textValue=doc.getElementsByTagName('text')
        var value='' //获取到的实时值
        let valueList=[]
        let ids=this.distinct(copy(this.ids))
      },
      //获取图形大小
      getPicSize () {
        var doc=this.$refs.svgframe.getSVGDocument().getElementsByTagName("svg")[0]
        var devices=doc.getElementsByTagName('rect')
        let width=devices[0].width.animVal.value
        let height=devices[0].height.animVal.value
        this.$emit('widthAndHeight',width,height)
      },
      distinct (arr) {
        //数组去重
        let newArr=[]
        for(let i=0;i<arr.length;i++) {
          if(!newArr.includes(arr[i])) {
            newArr.push(arr[i])
          }
        }
        return newArr
      },
      trendLine () {
        if(offset<=0) offset=1000;
        if(isempty(llines)||llines.length==0) {
          llines=$('#svgframe').contents().find("g polyline[class='leftdash']");
        }
        llines.each(function() {
          this.style.strokeDashoffset=offset;
        });
        if(isempty(rlines)||rlines.length==0) {
          rlines=$('#svgframe').contents().find("g polyline[class='rightdash']");
        }
        rlines.each(function() {
          this.style.strokeDashoffset=1000-offset;
        });
        offset=offset-2;
      }
    }
  }
</script>

<style scoped>
  .iframe {
    transform: translateY(-56px);
    width: 100%;
    height: calc(100vh - 28px);
    margin-bottom: -56px;
  }

  #app_svg_body {
    width: 100%;
    height: 100%;
    position: relative;
  }

  #svgframe {
    /*transform: rotate(90deg);*/
    /*-ms-transform: rotate(90deg);
		-moz-transform: rotate(90deg);
		-webkit-transform: rotate(90deg);
		-o-transform: rotate(90deg);*/
  }

  #svgframe svg {
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -o-transform: rotate(90deg);
  }

 

  .zoonContainer {
    position: absolute;
    width: 40px;
    right: 5px;
    top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .zoonContainer>div {}

  .zoon {
    cursor: pointer;
    width: 30px;
    padding: 5px;
    height: 30px;
    box-shadow: 0 0 5px silver;
  }

  .zoonOut {
    margin-top: 10px;
  }
</style>
<style>
  .zoonContainer .el-button {
    padding: 0;
  }

  .zoonContainer .el-button--primary.is-plain {
    background: rgba(0, 0, 0, 0);
    border-color: rgba(0, 0, 0, 0);
    color: #409EFF;
  }

  .zoonContainer .el-button--primary.is-plain:focus,
  .el-button--primary.is-plain:hover {
    color: #105caa;
  }

  .zoonContainer .el-button span {
    font-size: 30px;
    font-weight: 900;
  }
</style>